Number.prototype.toDurationString = function () {
  if (this.toString() === 'NaN') {
    return '00:00';
  }

  var minutes = Math.floor(this / 60);
  var seconds = Math.round(this - minutes * 60);

  if (minutes < 60) {
    return formatComponents(0, minutes, seconds);
  }

  var hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  return formatComponents(hours, minutes, seconds);
};

Number.prototype.toShortDurationString = function () {
  if (this.toString() === 'NaN') {
    return '00:00';
  }

  var minutes = Math.floor(this / 60);
  var seconds = Math.round(this - minutes * 60);

  if (seconds >= 30) {
    minutes += 1;
  }

  if (minutes < 60) {
    return formatComponents(0, minutes);
  }

  var hours = Math.floor(minutes / 60);
  minutes -= hours * 60;
  return formatComponents(hours, minutes);
};

Number.prototype.toLongDurationString = function () {
  if (this.toString() === 'NaN') {
    return '00:00';
  }

  var minutes = Math.floor(this / 60);
  var seconds = Math.round(this - minutes * 60);

  if (minutes < 60) {
    return formatComponents(0, 0, minutes, seconds);
  }

  var hours = Math.floor(minutes / 60);
  minutes -= hours * 60;

  if (hours < 24) {
    return formatComponents(0, hours, minutes, seconds);
  }

  var days = Math.floor(hours / 24);
  hours -= days * 24;
  formatComponents(days, hours, minutes, seconds);
};

function formatComponents() {
  for (var _len = arguments.length, components = new Array(_len), _key = 0; _key < _len; _key++) {
    components[_key] = arguments[_key];
  }

  return components.map(function (c) {
    return c.toString().padStart(2, '0');
  }).join(':');
}